//import { useState } from "react"

const SortForm = ({ sortField, setSortField, sortDirection, setSortDirection }) => {
 

  return (
    <>
      <label>Lajittele:</label>{' '}
      <select value={sortField} onChange={(e) => setSortField(e.target.value)}>
        <option value="title">Nimi</option>
        <option value="date">Julkaistu</option>
        <option value="modified">Muokattu</option>
      </select>
      {'  '}
      <label>
        {' '}
        Järjestys:
       
      </label>{' '}
      <select value={sortDirection} onChange={(e) => setSortDirection(e.target.value)}>
        <option value="nouseva">&#9650; {sortField === 'title' ? 'A-Ö' : 'Vanhin'} </option>
        <option value="laskeva">&#9660;  {sortField === 'title' ? 'Ö-A' : 'Uusin'}</option>
      </select>
    </>
  )
}
export default SortForm
